<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled'
                                     : props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="code"
                  label="Shop Type Code"
                  v-model="shopType.code"
                  type="text"
                  :rules="rules.codeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Shop Type Name"
                  v-model="shopType.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Shop Type Description"
                  v-model="shopType.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="shopType.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offest-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="shopType.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="shopType.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="shopType.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offest-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="shopType.id">
                <v-text-field
                  name="updatedBy"
                  label="Updated By"
                  v-model="shopType.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="shopType.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active':'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { ShopTypeFormRules } from "../../helpers/validation-rules";
import { ShopType } from "../../models/model";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { shopTypeService } from "../../services/shop-type-service";
import { commonService } from "../../services/common-service";
export default {
  name: "Shop Type Detail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "Shop Type",
        disabled: false,
        to: "shop-types"
      },
      {
        text: "Shop Type Detail",
        disabled: true
      }
    ],
    updatedDate: "",
    createdDate: "",
    responseError: "",
    statusFlag: true,
    saveLoading: false,
    rules: new ShopTypeFormRules(),
    shopType: new ShopType(),
    oldShopType: new ShopType()
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new shop type
    } else {
      this.getShopTypeDetail(id);
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.shopType.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
        let shopTypeObj = {
          id: this.shopType.id ? this.shopType.id : "",
          name: this.shopType.name,
          code: this.shopType.code,
          description: this.shopType.description,
          status: this.shopType.status
        };
        shopTypeService
          .saveShopType(shopTypeObj)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getShopTypeDetail(id) {
      shopTypeService
        .getShopTypeDetail(id)
        .then(res => {
          this.shopType = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.shopType.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.shopType.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.oldShopType = Object.assign({}, res.data);
          this.statusFlag = this.shopType.status == "ACTIVE" ? true : false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.shopType.id) {
        this.shopType = new ShopType();
        this.statusFlag = true;
      } else {
        this.shopType = Object.assign({}, this.oldShopType);
        this.statusFlag = this.shopType.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/shop-types");
    }
  }
};
</script>